import React from 'react';
import { Select } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';
import { PALETTES } from '../config/brand';
import { useI18n } from '../i18n';

const { Option } = Select;

export default function ThemeSelect({ value, onChange, width = 200 }) {
  const { t } = useI18n();

  return (
    <Select
      value={value}
      onChange={onChange}
      style={{ width }}
      suffixIcon={<BgColorsOutlined />}
    >
      {Object.values(PALETTES).map((palette) => (
        <Option key={palette.name} value={palette.name}>
          {t(palette.label)}
        </Option>
      ))}
    </Select>
  );
}
